import { Toaster as SonnerToaster, toast } from 'sonner';
import type { ComponentProps } from 'react';

type ToasterProps = ComponentProps<typeof SonnerToaster>;

/**
 * App-level toast outlet (sonner) themed with the design tokens. Mount once
 * near the root, then fire notifications with `toast.success(...)` etc.
 */
function Toaster(props: ToasterProps): React.JSX.Element {
  return (
    <SonnerToaster
      position="top-right"
      toastOptions={{
        classNames: {
          toast:
            'group flex w-full items-start gap-3 rounded-md border border-border bg-card p-4 text-sm text-card-foreground',
          title: 'font-semibold',
          description: 'text-muted-foreground',
          success:
            'border-status-matched-border bg-status-matched-bg [&_[data-icon]]:text-status-matched',
          warning:
            'border-status-unmatched-border bg-status-unmatched-bg [&_[data-icon]]:text-status-unmatched',
          info: 'border-status-info-border bg-status-info-bg [&_[data-icon]]:text-status-info',
          error:
            'border-destructive bg-destructive [&_[data-title]]:text-destructive-foreground [&_[data-description]]:text-destructive-foreground [&_[data-icon]]:text-destructive-foreground [&_[data-close-button]]:text-destructive-foreground',
        },
      }}
      {...props}
    />
  );
}

export { Toaster, toast };
